import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új adatátadási esemény',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Adatok',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'seeDetails'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "dataTransferName",
                label: "Név",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "transferStatus",
                label: "Státusz",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "dataManagementProcess",
                label: "Adatkezelési folyamat",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "addressee",
                label: "Címzettek",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "transferForm",
                label: "Átadási forma",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "transferDateFrom",
                label: "Dátumtól",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "transferDateTo",
                label: "Dátumig",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "dataTransferName",
                label: "Név",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "transferStatus",
                label: "Státusz",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dataManagementProcess",
                label: "Adatkezelési folyamat",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "transferDate",
                label: "Dátum",
                sort: true,
                visibility: false,
                formType: 'date',
                formSize: 3,
                formVisible: true,
                formRequired: true,
            },
            {
                name: "addressee",
                label: "Címzettek",
                visibility: true,
                formType: 'text',
                formSize: 3,
                formRequired: true,
                formVisible: true
            },
            {
                name: "transferForm",
                label: "Átadási forma",
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true,
            },
            {
                name: "transferFrequencies",
                label: "Átadás gyakorisága",
                visibility: false,
                formSize: 6,
                formRequired: true,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getTransferFreqFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ],

        detailsFormIsOpen: false,
        detailsGridIsOpen: false,
        detailsDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        detailsActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToEventGrid'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új adatátadási esemény adat',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newDetailRow'
            }
        ],
        detailsFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToDetailGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetDetailForm'
            }
        ],
        detailsRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyDetailRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteDetailRow'
            }
        ],
        detailsHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "siteId",
                label: "Telephely ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "transferId",
                label: "Transfer ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "expectedSecurityMeasure",
                label: "Elvárt biztonsági intézkedés",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 9,
                formRequired: true,
                formVisible: true
            },
            {
                name: "personalData.username",
                label: "Személy",
                visibility: true,
                formVisible: false
            },
            {
                name: "personalDataId",
                label: "Személy",
                visibility: false,
                formSize: 3,
                formRequired: true,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ],
    }
}
